import { analyticsService } from 'utils/services/analytics'

export const AiStepWizardAnalytics = {
  logExitPollSubmitted: (data: { comment: string }) =>
    analyticsService.sendEvent('AI_STEP_WIZARD.EXIT_POLL.SUBMIT', data),
  logAgentApplied: (data: { nodeId: string; sessionId: string }) =>
    analyticsService.sendEvent('AI_STEP_WIZARD.AGENT_APPLIED', data),
}
